<template>
  <div>
    <div class="head-container">
      <img src="@/assets/images/icon/icon-warning_2.svg" />
      <p>{{ $t('유해·위험 기계·기구 설비 배치 현황도') }}</p>
    </div>
    <div id="map-layout">
      <MapSvg81 v-if="companyId === 81" />
      <MapSvg85 v-else-if="companyId === 85" />
      <MapSvg84 v-else-if="companyId === 84" />
      <MapSvg83 v-else />
    </div>
  </div>
</template>

<script>
import MapSvg81 from './components/MapSvg81.vue';
import MapSvg85 from './components/MapSvg85.vue';
import MapSvg84 from './components/MapSvg84.vue';
import MapSvg83 from './components/MapSvg83.vue';

export default {
  components: {
    MapSvg81,
    MapSvg85,
    MapSvg84,
    MapSvg83,
  },
  props: {
    year: Number,
  },
  data() {
    return {
      warningData: {
        forging_press_750: "단조프레스(750t)",
        forging_press_1350: "단조프레스(1350t)",
        trimming_press: "트리밍프레스(150t)",
        induction_heater: "유도가열장치",
        die_storage: "금형적재대",
        cutting_material_storage: "절단소재보관장소",
        finished_goods_storage: "제품재고보관장소",
        round_bar_storage: "환봉적재장소",
        cutting_press: "절단프레스(400t)",
        shipping_staging: "출하제품대기",
        shot_machine_300: "쇼트기(300k)",
        shot_machine_100: "쇼트기(100k)",
      },

      warningKeys: [],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    companyId() {
      return this.$store.state.auth.userInfo.company_id;
    },
  },
  watch: {
    year() {
      this.resetCrispEdgePathsToSt0();
      this.loadPosts();
    },
  },
  created() {
    this.loadPosts();
  },
  methods: {
    async loadPosts() {
      const projectId = this.projectId;
      const boardId = 688;
      const page = 1;
      const perPage = 1000;

      const conditions = [
        { key: "created_at", operator: ">=", value: `${this.year}-01-01` },
        { key: "created_at", operator: "<", value: `${this.year + 1}-01-01` },
      ];

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId,
        boardId,
        page,
        perPage,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions,
      });

      const allMatchedKeys = new Set();
      response.data.map((item) => {
        const content = JSON.parse(item.post_content).body;
        content.riskAppraisalList.map((riskItem) => {
          const targetRisk = riskItem.사진내용;
          const riskSelect = riskItem.input_5 === "직접입력" ? riskItem.input_5_0 : riskItem.input_5;
          if (!targetRisk) return;
          if (!riskSelect || riskSelect === "해당없음") return;

          allMatchedKeys.add(targetRisk);
        });
      });

      console.log("allMatchedKeys", allMatchedKeys);

      this.warningKeys = Array.from(allMatchedKeys);
      this.highlightWarning();
    },

    // warningKeys의 데이터로 svg label 데이터를 색칠한다.
    highlightWarning() {
      const svg = document.getElementById("map-layout");
      if (!svg) return;

      const valueToKey = Object.entries(this.warningData).reduce((acc, [key, value]) => {
        acc[value] = key;
        return acc;
      }, {});

      this.warningKeys.forEach((value) => {
        const key = valueToKey[value];
        if (!key) return;

        const elements = svg.querySelectorAll(`[id^="label_${key}"]`);
        console.log("elements", elements)
        elements.forEach((group) => {
          const crispPaths = group.querySelectorAll('[shape-rendering="crispEdges"]');
          crispPaths.forEach((path) => {
            path.setAttribute("class", "st2");
          });
        });
      });
    },

    resetCrispEdgePathsToSt0() {
      const svg = document.getElementById("map-layout");
      if (!svg) return;

      const crispPaths = svg.querySelectorAll('[shape-rendering="crispEdges"]');

      crispPaths.forEach((path) => {
        path.setAttribute("class", "st0");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.head-container {
  display: flex;
  align-items: center;

  border: solid 1px #cdcdcd;
  border-radius: 5px;
  margin-bottom: 24px;
  overflow: hidden;

  img {
    background-color: #1e0d61;
    padding: 12px;
  }

  p {
    font-weight: 700;
    font-size: 18px;

    padding: 0 16px;
    margin-bottom: 2px;
  }
}

#map-layout {
  border: solid 1px #cdcdcd;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='2' fill='#ebebeb' /%3E%3C/svg%3E");
}

// =============== SVG ====================
.st0 {
  fill: #2d2d2d;
}
.st1 {
  fill: #fff;
}
.st2 {
  fill: #c32429;
}
.st3 {
  stroke: #e8e8e8;
}
.st3,
.st4 {
  fill: none;
}
.st4 {
  stroke: #1e0d61;
  stroke-opacity: 0.6;
}
.st5 {
  fill: #a190e4;
  fill-opacity: 0.3;
}
</style>
